module.exports = __webpack_public_path__ + "static/media/national-2-web-light.179283dc.eot";